(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      }
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      )
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }
  }

  customElements.define('localization-form', LocalizationForm)

  /* ─────────────────────────────────────────────────────────
     Mobile footer accordion, built on native <details>/<summary>.
     The browser itself guarantees the <summary> (title + icon)
     is ALWAYS rendered and clickable — open or closed — so it
     can never disappear the way a custom show/hide class can.

     - Desktop: every panel is forced open (matches the old,
       always-expanded design) and clicking does nothing.
     - Mobile: panels start closed; opening one closes the rest
       (standard single-open accordion). Native click-to-toggle
       on <summary> needs no extra JS at all.
     ───────────────────────────────────────────────────────── */
  function initFooterAccordion() {
    var panels = document.querySelectorAll('.footer__menu--collapsible')
    if (!panels.length) return

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches
    }

    function forceOpenAll() {
      panels.forEach(function (panel) {
        panel.open = true
      })
    }

    function closeAllOnMobile() {
      panels.forEach(function (panel) {
        panel.open = false
      })
    }

    function applyResponsiveState() {
      if (isMobile()) {
        closeAllOnMobile()
      } else {
        forceOpenAll()
      }
    }

    applyResponsiveState()

    panels.forEach(function (panel) {
      if (panel.dataset.accordionBound === 'true') return
      panel.dataset.accordionBound = 'true'

      // Fires on every open/close, whether triggered by click,
      // keyboard, or our own script.
      panel.addEventListener('toggle', function () {
        if (!isMobile()) return
        if (panel.open) {
          panels.forEach(function (other) {
            if (other !== panel) other.open = false
          })
        }
      })
    })

    var resizeTimer
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(function () {
        if (!isMobile()) forceOpenAll()
      }, 150)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion)
  } else {
    initFooterAccordion()
  }

  document.addEventListener('shopify:section:load', initFooterAccordion)

  } catch(e) { console.error(e); }
})();
})();
